import { api } from '../../lib/api';
import type {
  FeedbackCategory,
  FeedbackDetail,
  FeedbackListResponse,
  FeedbackSource,
  FeedbackStatus,
  FeedbackReply,
} from './types';

export interface FeedbackFilters {
  status?: FeedbackStatus;
  source?: FeedbackSource;
  category?: FeedbackCategory;
  search?: string;
  from?: string;
  to?: string;
  cursor?: string | null;
  limit?: number;
  app?: string; // Admin-Picker: Feedback ist pro App (Tenant)
}

export function sendFeedbackReply(id: string, app: string, body: string, requestId: string): Promise<FeedbackReply> {
  return api.post(`/admin/feedback/${id}/reply?app=${encodeURIComponent(app)}`, { body, requestId });
}

export function retryFeedbackEmail(id: string, app: string, messageId: string): Promise<FeedbackReply> {
  return api.post(`/admin/feedback/${id}/replies/${messageId}/retry-email?app=${encodeURIComponent(app)}`, {});
}

function qs(filters: FeedbackFilters): string {
  const p = new URLSearchParams();
  if (filters.app) p.set('app', filters.app);
  if (filters.status) p.set('status', filters.status);
  if (filters.source) p.set('source', filters.source);
  if (filters.category) p.set('category', filters.category);
  if (filters.search) p.set('search', filters.search);
  if (filters.from) p.set('from', filters.from);
  if (filters.to) p.set('to', filters.to);
  if (filters.cursor) p.set('cursor', filters.cursor);
  if (filters.limit) p.set('limit', String(filters.limit));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function fetchFeedback(filters: FeedbackFilters = {}): Promise<FeedbackListResponse> {
  return api.get<FeedbackListResponse>(`/admin/feedback${qs(filters)}`);
}

export function fetchFeedbackDetail(id: string, app: string): Promise<FeedbackDetail> {
  return api.get<FeedbackDetail>(`/admin/feedback/${id}?app=${encodeURIComponent(app)}`);
}

export interface FeedbackUpdate {
  status?: FeedbackStatus;
  tags?: string[];
  internalNote?: string | null;
}

export function updateFeedback(
  id: string,
  patch: FeedbackUpdate,
  app: string,
): Promise<FeedbackDetail> {
  return api.patch<FeedbackDetail>(`/admin/feedback/${id}?app=${encodeURIComponent(app)}`, patch);
}
